<template>
  <div class="SellReportPage page">
    <div class="page-title">
      <span>{{$t('product_report')}}</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{ getStoreConfig().currency }}</option>
          <option
            v-for="rate in (getCurrencyRates)"
            :value="rate.toCurrency"
            :key="rate.id"
          >
          {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" @onChangeProductType="onChangeProductType" :disableCompareDate="false" :queryMode="this.query.mode"/>
    <UiReportList :reportList="reportList" />
    <div class="dropdown-wrap">
      <select name="outlet" v-model="catalogId" @change="onChangeCatalog">
        <option :value="null">{{ $t("all_category") }}</option>
        <option :value="'Uncategorized'">{{ $t("Uncategorized") }}</option>
        <option v-for="catalog in getListCatalog" :key="catalog.id" :value="catalog.id">{{ catalog.name }}</option>
      </select>
    </div>
    <UiTableReportCommon :report="productReport" :colsData="visibleFields" :showPagination="true" :typeGetData="typeGetData"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import localStorageKey from '@/constants/localStorageKey'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import UiReportList from '@/components/UiReportList'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
// import UiChart from '@/components/UiChart'
import UiTableReportCommon from '@/components/UiTableReportCommon'
import reportType from '@/config/reportType'
import reportList from '@/constants/reportList'
import i18n from '@/i18n'
export default {
  name: 'ProductProfitPage',
  components: {
    UiFilterbar,
    // UiChart,
    UiReportList,
    UiTableReportCommon
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        productCategoryId: null,
        timeZone,
        reportingMode: 'in_store'
      },
      reportList: reportList.products,
      filterType: 'DATE',
      catalogId: null,
      type: 'products',
      fields: [
        { key: 'sku', label: 'sku', visible: true },
        { key: 'name', label: 'product_title', visible: true },
        { key: 'additionalData', label: 'variants', visible: true },
        { key: 'totalPrice', label: 'total_price', visible: true },
        { key: 'cost', label: 'cost', visible: true },
        { key: 'grossProfit', label: 'gross_profit', visible: true },
        { key: 'margin', label: 'margin', visible: true }
      ],
      loaded: false
    }
  },
  watch: {
    getListOutLet: function (val) {
      this.outletItem = this.getQuery.outletId || null
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      reportQuery: 'report/getQuery',
      productReport: 'report/getProductReportData',
      getListCatalog: 'catalog/getListCatalog',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates'
    }),
    visibleFields () {
      return this.fields.filter(field => field.visible)
    },
    typeGetData () {
      return reportType.productProfit
    }
  },
  updated () {
    const catalog = this.getListCatalog.find((catalog) => catalog.id === this.catalogId)
    if (!catalog && this.catalogId !== 'Uncategorized') {
      this.catalogId = null
    }
  },
  beforeRouteLeave(to, from, next) {
    this.resetQueryReport({
      type: reportType.productProfit,
      query: {
        ...this.query,
        ...this.day,
        productCategoryId: null
      }
    })
    next()
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      getCatalog: 'catalog/getListCatalogByOulet',
      resetQueryReport: 'report/resetQueryReport'
    }),
    selectCurrency () {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }

      this.getReport({
        type: reportType.productProfit,
        query: {
          ...this.query,
          ...this.day
        }
      })
    },
    getStoreConfig () {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses, productTypes) {
      this.query.states = states
      this.query.statuses = statuses
      this.query.productTypes = productTypes
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.productProfit,
        query: {
          ...this.query,
          ...day,
          states,
          statuses,
          productTypes
        }
      })
    },
    onDefaultFilter (day, type, reportingMode, outletIds, registerIds) {
      this.day = day
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.query.productCategoryId = null
      this.getReport({
        type: reportType.productProfit,
        query: {
          ...this.query,
          ...day,
          productCategoryId: null
        }
      })
    },
    onChangeProductType (reportingMode, outletIds, registerIds, day, type, productTypes) {
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.productProfit,
        query: {
          ...this.query,
          ...day,
          productTypes
        }
      })
    },
    onChangeCatalog () {
      this.query.productCategoryId = this.catalogId
      this.getReport({
        type: reportType.productProfit,
        query: {
          ...this.reportQuery,
          page: 1,
          productCategoryId: this.catalogId === 'Uncategorized' ? 'uncategorized' : this.catalogId
        }
      })
    },
    prepareChartOptions (reports) {
      const productList = reports && reports.items ? reports.items.map(item => item.name) : []
      return {
        chart: {
          id: 'product-sold-chart',
          type: 'bar',
          width: productList.length < 50 ? '100%' : Math.max(document.body.offsetWidth - 120, productList.length * 30),
          zoom: {
            enabled: false
          },
          background: '#fff'
        },
        dataLabels: {
          style: {
            colors: ['#000000']
          }
        },
        plotOptions: {
          bar: {
            columnWidth: productList.length === 1 ? '15%' : productList.length <= 3 ? '30%' : '70%'
          }
        },
        noData: {
          text: i18n.t('no_data')
        },
        tooltip: {
          x: {
            formatter: (name) => name
          }
        },
        xaxis: {
          categories: productList,
          labels: {
            formatter: function (value) {
              if (value.length > 10) return value.substring(0, 10) + '...'
              return value
            }
          }
        }
      }
    },
    prepareChartSeries (reports) {
      const valueList = reports && reports.items ? reports.items.map(item => item.netQtySold || 0) : []
      return [{
        name: i18n.t('net_quantity_sold'),
        data: valueList
      }]
    },
    isNotUseStoreCurrency (currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    }
  },
  created () {
    const currenStore = getItemByLocalStorage(localStorageKey.STORE_ID)
    const currenOutlets = JSON.parse(getItemByLocalStorage(localStorageKey.CURRENT_OUTLET_ID) || '[]')
    if ((this.getListCatalog || []).length < 1) {
      this.getCatalog(currenStore, currenOutlets)
    }
    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    }
  }
}
</script>

<style lang="scss" scoped>
  .page {
    padding: 0 30px;
    .chart-wrapper {
      width: 100%;
      overflow: auto;
    }
  }
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 140px;
      outline: none;
      border-radius: 4px;
      border: 1px solid #818181;
      background-color: #fff;
    }
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0 30px;
  }
  ul {
    position: absolute;
    text-align: left;
    right: 0;
    background: #e9eef1;
    padding: 20px;
    top: 100%;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    z-index: 12;

    li {
      padding: 5px 0;

      label {
        cursor: pointer;
      }
    }
  }
  .dropdown-wrap {
    margin-bottom: 15px;

    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 100px;
      outline: none;
      border-radius: 4px;
      border: 0;
      background-color: #fff;
    }
  }
</style>
